import type { TableHeaderCellUpdatePanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";
import { useDeleteTableHeaderCellFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: TableHeaderCellUpdatePanelFragment;
};

export function TableHeaderCellUpdatePanel({ fragment }: Props) {
  const { t } = useTranslation();
  const [deleteAttribute] = useDeleteTableHeaderCellFromPanelMutation();

  const onSave = async () => {};

  const onDelete = async () => {
    await deleteAttribute({
      variables: { attributeId: fragment.id },
      update(cache) {
        const id = cache.identify(fragment);
        cache.evict({ id });
        cache.gc();
      },
    });
  };

  return (
    <AttributePanel
      title={t("TableHeaderCellUpdatePanel.title")}
      onSubmit={onSave}
      onDelete={onDelete}
    />
  );
}
